import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { combineLatest, map, take } from 'rxjs';

import { TermsOfUseItem } from '@app/core/models/terms-of-use-item.model';

import { AuthSessionService } from '@core/services/auth-session.service';

function allTermsAccepted(rows: TermsOfUseItem[]): boolean {
  if (rows.length === 0) {
    return true;
  }

  return rows.every((row) => row.accepted === true);
}

function getFirstPendingTermId(rows: TermsOfUseItem[]): number | undefined {
  const pending = rows.find((row) => row.accepted !== true);

  if (pending === undefined) {
    return undefined;
  }

  const termId = pending.termId;

  if (typeof termId !== 'number') {
    return undefined;
  }
  return termId;
}

function evaluateTermsAcceptance(params: {
  router: Router;
  termsOfUse: TermsOfUseItem[];
  hasUser: boolean;
}): boolean | UrlTree {
  const { router, termsOfUse, hasUser } = params;

  if (!hasUser) {
    return true;
  }

  if (allTermsAccepted(termsOfUse)) {
    return true;
  }

  const termId = getFirstPendingTermId(termsOfUse);

  if (termId === undefined) {
    console.warn(
      'Termos: lista vazia, pendência sem id — termos-indisponiveis'
    );
    return router.createUrlTree(['/termos-indisponiveis']);
  }

  return router.createUrlTree(['/aceite-de-termos', termId]);
}

export const termsAcceptanceGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthSessionService);

  return combineLatest([auth.session$, auth.termsOfUse$]).pipe(
    take(1),
    map(([session, termsOfUse]) =>
      evaluateTermsAcceptance({
        router,
        hasUser: !!session?.user,
        termsOfUse
      })
    )
  );
};
